"use strict";
// Copyright (c) StrangeBee 2023
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const errors_1 = require("../../errors");
const utils_1 = require("../../utils");
class UISettingsController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            edit: '/config/organisation/ui.:objectId',
            list: '/config/organisation?path=ui',
        };
    }
    list() {
        try {
            return this.manager.get({ url: this.endpoints.list });
        }
        catch (e) {
            (0, utils_1.errorManager)(e, errors_1.GenericError, {
                prefix: 'Cannot retrieve UI settings',
                errors: [{ statusCode: 404 }],
            });
        }
    }
    multiEdit(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const request = Object.entries(params).map(([objectId, value]) => this.manager.put({ url: this.endpoints.edit, params: { objectId } }, { value }));
                return Promise.all(request);
            }
            catch (e) {
                (0, utils_1.errorManager)(e, errors_1.GenericError, {
                    prefix: 'Cannot edit UI settings',
                    errors: [{ statusCode: 400 }],
                });
            }
        });
    }
    count() {
        throw new Error("Can't count UISettings");
    }
    create({}) {
        throw new Error("Can't create UISettings!");
    }
    delete() {
        throw new Error("Can't delete UISettings!");
    }
}
exports.default = UISettingsController;
